import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import { useState, Fragment, useEffect } from 'react'
import { Formik, Form } from 'formik'
import Fields from '@components/fields'
import Button from '@components/button'
import { StyleConsultWrapper, StyleConsultItem } from './style'
import { Appointment } from '@apis'
import { useSelector } from 'react-redux'
const Consultation = ({ canSave = false }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const { data: appointment } = useSelector(
    (state: any) => state.consultAppointment,
  )
  const isDisable =
    appointment?.status == 'On Going' || appointment?.status == 'Completed'
      ? false
      : true
  const [initialValues, setInitialValues] = useState({
    treatments: [''],
    issues: [''],
    examinations: [''],
    investigations: [''],
    reports: [],
  })
  const submitHandler = async (values: any) => {
    setLoading(true)
    const treatments = values?.treatments?.filter(
      (treatment: any) => !!treatment,
    )
    const issues = values?.issues?.filter((issue) => !!issue)
    const investigations = values?.investigations?.filter(
      (investigation) => !!investigation,
    )
    const examinations = values?.examinations?.filter(
      (examination) => !!examination,
    )
    if (
      !treatments?.length &&
      !issues?.length &&
      !investigations?.length &&
      !examinations?.length
    ) {
      setLoading(false)
      return
    }
    const paylaod: any = {}
    if (!!treatments?.length) {
      paylaod.treatments = treatments
    }
    if (!!issues?.length) {
      paylaod.issues = issues
    }
    if (!!investigations?.length) {
      paylaod.investigations = investigations
    }
    if (!!examinations?.length) {
      paylaod.examinations = examinations
    }
    await Appointment.update({
      data: paylaod,
      id: appointment?.id,
      state: 'consultAppointment',
    }).catch(() => {})
    setLoading(false)
  }

  useEffect(() => {
    setInitialValues({
      treatments: appointment?.infos?.treatments || [''],
      issues: appointment?.infos?.issues || [''],
      examinations: appointment?.infos?.examinations || [''],
      investigations: appointment?.infos?.investigations || [''],
      reports: [],
    })
  }, [appointment?.id])
  return (
    <Column rowGap={20}>
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
      >
        {({ handleSubmit, values, setFieldValue }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Column rowGap={20}>
                <Column
                  bg="white"
                  styleColumn="border-radius:12px;padding:20px;"
                  rowGap={15}
                >
                  <CardHeading title="Issues" tc="primary" />
                  <StyleConsultWrapper>
                    {values?.issues?.map((_, index) => {
                      return (
                        <Fragment key={index}>
                          <StyleConsultItem>
                            <Fields.Input
                              name={`issues[${index}]`}
                              placeholder="Enter issues"
                              styleInput="
                                border:0px;
                              "
                              onChange={(text) => {
                                setFieldValue(`issues[${index}]`, text)
                                if (index != 0) {
                                  if (!text) {
                                    setFieldValue(
                                      'issues',
                                      values?.issues?.filter(
                                        (_, i) => i != index,
                                      ),
                                    )
                                  }
                                }
                              }}
                              onKeyDown={(e: any) => {
                                if (e.key == 'Enter') {
                                  e.preventDefault()
                                  setFieldValue('issues', [
                                    ...values?.issues,
                                    '',
                                  ])
                                }
                              }}
                              disabled={isDisable}
                            />
                          </StyleConsultItem>
                        </Fragment>
                      )
                    })}
                  </StyleConsultWrapper>
                </Column>
                <Column
                  bg="white"
                  styleColumn="border-radius:12px;padding:20px;"
                  rowGap={15}
                >
                  <CardHeading title="Examination" tc="primary" />
                  <StyleConsultWrapper>
                    {values?.examinations?.map((_, index) => {
                      return (
                        <Fragment key={index}>
                          <StyleConsultItem>
                            <Fields.Input
                              name={`examinations[${index}]`}
                              placeholder="Enter examination"
                              styleInput="
                                border:0px;
                              "
                              onChange={(text) => {
                                setFieldValue(`examinations[${index}]`, text)
                                if (index != 0) {
                                  if (!text) {
                                    setFieldValue(
                                      'examinations',
                                      values?.examinations?.filter(
                                        (_, i) => i != index,
                                      ),
                                    )
                                  }
                                }
                              }}
                              onKeyDown={(e: any) => {
                                if (e.key == 'Enter') {
                                  e.preventDefault()
                                  setFieldValue('examinations', [
                                    ...values?.examinations,
                                    '',
                                  ])
                                }
                              }}
                              disabled={isDisable}
                            />
                          </StyleConsultItem>
                        </Fragment>
                      )
                    })}
                  </StyleConsultWrapper>
                </Column>
                <Column
                  bg="white"
                  styleColumn="border-radius:12px;padding:20px;"
                  rowGap={15}
                >
                  <CardHeading title="Investigation" tc="primary" />
                  <StyleConsultWrapper>
                    {values?.investigations?.map((_, index) => {
                      return (
                        <Fragment key={index}>
                          <StyleConsultItem>
                            <Fields.Input
                              name={`investigations[${index}]`}
                              placeholder="Enter Investigation"
                              styleInput="
                                border:0px;
                              "
                              onChange={(text) => {
                                setFieldValue(`investigations[${index}]`, text)
                                if (index != 0) {
                                  if (!text) {
                                    setFieldValue(
                                      'investigations',
                                      values?.investigations?.filter(
                                        (_, i) => i != index,
                                      ),
                                    )
                                  }
                                }
                              }}
                              onKeyDown={(e: any) => {
                                if (e.key == 'Enter') {
                                  e.preventDefault()
                                  setFieldValue('investigations', [
                                    ...values?.investigations,
                                    '',
                                  ])
                                }
                              }}
                              disabled={isDisable}
                            />
                          </StyleConsultItem>
                        </Fragment>
                      )
                    })}
                  </StyleConsultWrapper>
                </Column>
                <Column
                  bg="white"
                  styleColumn="border-radius:12px;padding:20px;"
                  rowGap={15}
                >
                  <CardHeading title="Treatment" tc="primary" />
                  <StyleConsultWrapper>
                    {values?.treatments?.map((_, index) => {
                      return (
                        <Fragment key={index}>
                          <StyleConsultItem>
                            <Fields.Input
                              name={`treatments[${index}]`}
                              placeholder="Enter treatment"
                              styleInput="
                                border:0px;
                              "
                              onChange={(text) => {
                                setFieldValue(`treatments[${index}]`, text)
                                if (index != 0) {
                                  if (!text) {
                                    setFieldValue(
                                      'treatments',
                                      values?.treatments?.filter(
                                        (_, i) => i != index,
                                      ),
                                    )
                                  }
                                }
                              }}
                              onKeyDown={(e: any) => {
                                if (e.key == 'Enter') {
                                  e.preventDefault()
                                  setFieldValue('treatments', [
                                    ...values?.treatments,
                                    '',
                                  ])
                                }
                              }}
                              disabled={isDisable}
                            />
                          </StyleConsultItem>
                        </Fragment>
                      )
                    })}
                  </StyleConsultWrapper>
                </Column>
                {!!canSave && (
                  <Column alignItems="flex-end">
                    <Button
                      title="Save"
                      height={40}
                      loading={loading}
                      type="submit"
                    />
                  </Column>
                )}
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Column>
  )
}

export default Consultation
